export default class DialogUtils {
	private static ariaRolesAttachmentQueued = false;

	constructor() {
		throw new Error('This is not constructable');
	}

	public static attachColorboxAriaRoles() {
		if (!DialogUtils.ariaRolesAttachmentQueued) {
			DialogUtils.ariaRolesAttachmentQueued = true;
			if (DialogUtils.actuallyAttachColorboxAriaRoles()) {
				return;
			}
			const observer = new MutationObserver(() => {
				if (DialogUtils.actuallyAttachColorboxAriaRoles()) {
					observer.disconnect();
				}
			});
			observer.observe(document, {subtree: true, childList: true});
		}
	}
	private static actuallyAttachColorboxAriaRoles() {
		const cbox = document.getElementById('colorbox');
		if (cbox) {
			cbox.setAttribute('aria-modal', 'true');
			return true;
		}
		return false;
	}

	public static focusLock(context?: HTMLElement) {
		const dialog: HTMLElement = context?.closest('[role="dialog"]') ?? document.querySelector('[role="dialog"]');
		if (dialog) {
			const firstFocusableElement: HTMLElement = dialog.querySelector('.first-focusable-element');
			const lastFocusableElement: HTMLElement = dialog.querySelector('.last-focusable-element');

			dialog.addEventListener('keydown', event => {
				// console.log(event);
				if (event.target === firstFocusableElement && event.key == 'Tab' && event.shiftKey) {
					event.preventDefault();
					lastFocusableElement.focus();
				} else if (event.target === lastFocusableElement && event.key == 'Tab' && !event.shiftKey) {
					event.preventDefault();
					firstFocusableElement.focus();
				}
			});
		}
	}
}
